import React from "react";
import { Box } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import { Map } from "components/Organismos/Map";

export const ConsultaPrevia = () => {
  return (
    <Box h="100%" position="relative">
      <Map>
        <Outlet />
      </Map>
    </Box>
  );
};
